import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import store from './store'
import * as types from './store/mutation-types'
import api from './utils/api'
import SimpleVueValidation from 'simple-vue-validator'
import '@mdi/font/css/materialdesignicons.css'
import VTooltip from 'v-tooltip'
import RpIcon from '@/utils/RpIcon'
import moment from 'moment'
import VueMq from 'vue-mq'
import {initializePush} from './utils/push.js'
import Vuetify from 'vuetify'
import './stylus/main.styl'
import colors from 'vuetify/es5/util/colors'
import VueYouTubeEmbed from 'vue-youtube-embed'

let pallete = {
  primary: colors.teal.base,
  secondary: colors.teal.darken2,
  accent: colors.amber.darken4,
  tertiary: colors.lightBlue.darken3,
  error: colors.red.base,
  warning: colors.yellow.darken1,
  info: colors.blue.lighten2,
  success: colors.green.base
}

Vue.use(VueMq, {
  breakpoints: { // default breakpoints - customize this
    sm: 960,
    md: 1250,
    lg: Infinity
  }
})

moment.locale('pl')

SimpleVueValidation.extendTemplates({
  required: 'To pole jest wymagane',
  email: 'Niepoprawny adres e-mail',
  between: 'Wartość musi znajdować się pomiędzy {0} a {1}.',
  optionCombiner: function (options) {
    if (options.length > 2) {
      options = [options.slice(0, options.length - 1).join('，'), options[options.length - 1]]
    }
    return options.join(' lub ')
  }
})
const pl = {
  dataIterator: {
    rowsPerPageText: 'Pozycji na stronie:',
    rowsPerPageAll: 'Wszystkie',
    pageText: '{0}-{1} z {2}',
    noResultsText: 'Nie znaleziono danych',
    nextPage: 'Następna strona',
    prevPage: 'Poprzednia strona'
  },
  dataTable: {
    rowsPerPageText: 'Wierszy na stronie:'
  },
  noDataText: 'Brak danych'
}
Vue.use(SimpleVueValidation)
Vue.use(VueYouTubeEmbed)
Vue.use(Vuex)
Vue.use(VTooltip)
Vue.use(Vuetify, {
  theme: pallete,
  lang: {
    locales: { pl },
    current: 'pl'
  }
})
Vue.component('rp-icon', RpIcon)

Vue.filter('default', function (input, property) {
  return (input === undefined || input === '' || input === null) ? property : input
})

Vue.filter('formatDate', function (value, format) {
  if (value) {
    return moment(String(value)).format(format)
  }
})

Vue.config.productionTip = false

const token = localStorage.getItem('user-token')
var promise
if (token) {
  api.defaults.headers.common['Authorization'] = 'Token ' + token
  promise = store.dispatch(types.USER_REQUEST)
} else {
  promise = Promise.resolve(null)
}

promise.finally(() => {
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    store,
    router,
    template: '<App/>',
    components: { App }
  })
  initializePush()
})



// WEBPACK FOOTER //
// ./src/main.js